import { useEffect, useState } from "react"
import CallToAction from "components/CallToAction"
import DynamicVideo from "components/DynamicVideo"

export default function VideoGrid({ blok }) {
  const [videoNumber, setVideoNumber] = useState(0)

  useEffect(() => {
    window !== undefined && window.innerWidth > 768 ? setVideoNumber(6) : setVideoNumber(3)
  }, [])

  let videos = blok.videos.length <= 6 ? blok.videos : blok.videos.slice(0, videoNumber)

  return (
    <section className="bg-grayPawprint px-8 py-12">
      {blok.title ? <h2 className="text-white text-center pb-6 lg:pb-12 uppercase">{blok.title}</h2> : null}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-screen-xl mx-auto">
        {videos.map((video, idx) => (
          <DynamicVideo {...video} key={idx} />
        ))}
      </div>
      {videos.length < blok.videos.length ? (
        <CallToAction className="table mx-auto mt-6" onClick={() => setVideoNumber(videoNumber + 6)} button>
          load more
        </CallToAction>
      ) : null}
    </section>
  )
}
